// extracted by mini-css-extract-plugin
module.exports = {"fallback":"N0UhNXrm","flag":"S4jbxUAu","rounded":"_GYT7de0","circular":"qD11oEar"};